function ShareIcon() {
  return (
    <svg width={16} height={18} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13 12.4c-.633 0-1.2.25-1.633.642L5.425 9.583C5.467 9.392 5.5 9.2 5.5 9c0-.2-.033-.392-.075-.583L11.3 4.992a2.49 2.49 0 0 0 1.7.675c1.383 0 2.5-1.117 2.5-2.5 0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5c0 .2.033.391.075.583L4.7 7.175A2.49 2.49 0 0 0 3 6.5 2.497 2.497 0 0 0 .5 9c0 1.383 1.117 2.5 2.5 2.5a2.49 2.49 0 0 0 1.7-.675l5.933 3.467a2.355 2.355 0 0 0-.066.541A2.436 2.436 0 0 0 13 17.267a2.436 2.436 0 0 0 2.433-2.434A2.436 2.436 0 0 0 13 12.4Zm0-10.067c.458 0 .833.375.833.834A.836.836 0 0 1 13 4a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834Zm-10 7.5A.836.836 0 0 1 2.167 9c0-.458.375-.833.833-.833.458 0 .833.375.833.833A.836.836 0 0 1 3 9.833Zm10 5.85a.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833Z'
        fill='#333'
      />
    </svg>
  );
}

export default ShareIcon;
